import Footer from '../layout/Footer';

import styles from './ErrorPage.module.scss';

const ErrorPage = ({ eventId = '' }: { eventId?: string }) => (
  <div className={styles.page}>
    <main className={styles.main}>
      <div className={styles.textBlock}>
        <h1>Something went wrong</h1>
        <span>
          We’ve encountered an unexpcted error.
          <br />
          Please, <a href={window.location.href}>try again</a> later or{' '}
          <a href="https://support.clearvpn.com/hc/requests/new">contact our support</a> for assistance.
        </span>

        {eventId && (
          <div>
            Error report number: <b>${eventId}</b>
          </div>
        )}
      </div>

      <img src="/images/alert-covers/fixel-wat.svg" width="162" height="154" alt="" />
    </main>
    <Footer />
  </div>
);

export default ErrorPage;
